import { OTA_VehAvailCore } from "./ota_vehavailcore.model";
import { OTA_VehAvailInfo } from "./ota_vehavailinfo.model";

export class OTA_VehAvail {
    public vehAvailCore = new OTA_VehAvailCore();
    public vehAvailInfo = new OTA_VehAvailInfo();
}